/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Primary/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Primary({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/Primary"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventAppointmentBookingStartTimeValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment.booking.start_time',
format: fromHelpers.isAppointmentToday,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(eventAppointmentBookingStartTimeValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}